<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="materialName" label="材料名称">
              {{ formData.materialName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="entryDate" label="进厂日期">
              {{ formData.entryDate || '--' }}

            </el-form-item>
          </el-col>

        </el-row>
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              {{ formData.productionDate || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号">
              {{ formData.plateNumber || '--' }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="supplierInfo" label="供应商信息">
              {{ formData.supplierInfoName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sampleDate" label="取样日期">
              {{ formData.sampleDate || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="testDate" label="检测日期">
              {{ formData.testDate || '--' }}

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="tankNumber" label="罐号">
              {{ formData.tankNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="quantity" label="数量">
              {{ formData.quantity || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="qualityGuaranteePeriod" label="保质期(月)">
              {{ formData.qualityGuaranteePeriod || '--' }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="supplierAddress" label="供应商地址">
              {{ formData.supplierAddress || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierContactNumber" label="联系方式">
              {{ formData.supplierContactNumber || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="supplierReportList" label="供应商检测报告">
              <file-upload view-type="img" readonly v-model="formData.supplierReportList"></file-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="factoryReportList" label="入厂检测报告">
              <file-upload view-type="img" readonly v-model="formData.factoryReportList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="leadSealAttachList" label="品控验收照片">
              <file-upload view-type="img" readonly v-model="formData.leadSealAttachList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="storageTransportAttachList" label="储运验收照片">
              <file-upload view-type="img" readonly v-model="formData.storageTransportAttachList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'ingredientsDetail',

  data() {
    return {
      formData: {

        entryDate: '',
        plateNumber: '',
        supplierInfo: '',
        productionDate: '',
        sampleDate: '',
        testDate: '',
        quantity: '',
        qualityGuaranteePeriod: '',
        supplierAddress: '',
        supplierContactNumber: '',
        supplierReportList: [],
        factoryReportList: [],
        leadSealAttachList: [],
        // 储运照片独立提交，原现场照片继续作为品控验收照片。
        storageTransportAttachList: [],
        materialName: ''
      },

      loading: false

    }
  },
  created() {
    if (this.inspectId) {
      this.loadData()
    }
  },
  computed: {
    inspectId() {
      return this.$route.query.inspectId
    },
    imageList1() {
      return this.formData.supplierReportList.map(item => {
        return item.filePrefix + item.fileUrl
      })
    },

    imageList2() {
      return this.formData.factoryReportList.map(item => {
        return item.filePrefix + item.fileUrl
      })
    },
    imageList3() {
      return this.formData.leadSealAttachList.map(item => {
        return item.filePrefix + item.fileUrl
      })
    }

  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.ingredients.selectPaMaterialInspectionByInspectId, {
          params: { inspectId: this.inspectId }
        })
        .then(res => {
          res.supplierReportList = res.supplierReportList ? res.supplierReportList : []
          res.factoryReportList = res.factoryReportList ? res.factoryReportList : []
          res.leadSealAttachList = res.leadSealAttachList ? res.leadSealAttachList : []
          res.storageTransportAttachList = res.storageTransportAttachList || []

          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-bottom: 10px;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.empty {
  color: #999;
  font-size: 14px;
}
</style>
